import { useTranslation } from 'next-i18next'
import html from 'html-react-parser'

import { getNavigationIcon } from '@/constants/navigationAssets'

import SearchHints from '../search/SearchHints'
import { useSearchBar } from '../search/useSearchBar'

import {
  Container,
  Heading,
  IconWrapper,
  Info,
  HintsContainer
} from './NoResults.styled'

function NoResults() {
  const { t } = useTranslation(['common', 'parkings'])
  const { cities } = useSearchBar(t)

  return (
    <Container>
      <IconWrapper>
        <img
          src={getNavigationIcon('noResults')}
          alt="No results found"
          loading="lazy"
        />
      </IconWrapper>
      <Heading>{html(t('parkings:noResults.title'))}</Heading>
      <HintsContainer>
        <Info>
          {html(t('parkings:noResults.info'))}{' '}
          <SearchHints fullWidth={true} cities={cities?.items} />
        </Info>
      </HintsContainer>
    </Container>
  )
}

export default NoResults
